import { isExternalPro } from "@/lib/api";

// Subapartados de Coordinación (menú lateral desplegable + página /coordinacion/:section).
export const isCoordUser = (u) => ["coordinadora", "directivo", "secretaria"].includes(u?.role)
    || (Array.isArray(u?.extra_permissions) && u.extra_permissions.includes("coordination"));

export const COORD_SECTIONS = [
    { key: "mis-coordinaciones", label: "Mis coordinaciones", title: "Mis coordinaciones" },
    { key: "reuniones", label: "Reuniones", title: "Reuniones" },
    { key: "alertas-informe-inicial", label: "Alertas de Informe Inicial", title: "Alertas de Informe Inicial (regla 30 días)" },
    { key: "pendientes-asignacion", label: "Pacientes Pendientes de Asignación", title: "Pacientes Pendientes de Asignación" },
    { key: "grupos", label: "Grupos terapéuticos", title: "Grupos terapéuticos" },
    { key: "recuperacion-pendiente", label: "Cancelaciones con recuperación pendiente", title: "Cancelaciones con recuperación pendiente (reprogramar)" },
    { key: "solicitudes-recuperacion", label: "Solicitudes de recuperación de sesión", title: "Solicitudes de recuperación de sesión (paciente propone fechas)" },
    { key: "firmas", label: "Informes pendientes de firma", title: "Informes pendientes de firma" },
    { key: "informes-editables", label: "Informes editables pendientes de firma", title: "Informes editables pendientes de firma" },
    { key: "reevaluaciones", label: "Pacientes que necesitan reevaluación", title: "Pacientes que necesitan reevaluación" },
];

// Externos sin permiso de coordinación: solo lo suyo.
export const EXTERNAL_SECTIONS = [
    { key: "mis-reuniones", label: "Mis reuniones", title: "Mis reuniones" },
    { key: "pais-pendientes", label: "PAÍS pendientes", title: "PAÍS pendientes" },
    { key: "mis-recuperaciones", label: "Mis recuperaciones pendientes", title: "Mis recuperaciones pendientes" },
];

const STAFF_KEYS = ["solicitudes-recuperacion", "firmas", "informes-editables", "reevaluaciones"];

export function coordSectionsFor(user) {
    if (isCoordUser(user)) return COORD_SECTIONS;
    if (isExternalPro(user)) return EXTERNAL_SECTIONS;
    return COORD_SECTIONS.filter((s) => STAFF_KEYS.includes(s.key));
}
